import React from "react"
import { useTranslation } from "react-i18next"

interface IProps{
  isGuest: boolean
}

export const GuestLabel: React.FC<IProps> = (props: IProps): JSX.Element  => {
  const { t } = useTranslation(["user"])
  if(!props.isGuest) return null
  return (
    <span className="text-sm text-white px-2 rounded bg-ch-blue-alt-500 ml-1 uppercase">
      {t("user:guest")}
    </span>
  )
}
